













import { PageMode } from '@/main/utils/pageMode';

import { BaseSelect, selectName } from '#components/baseSelect';

import { apiProvider } from '../api';
import { NAME } from '../constants';

type Data = {
	OJ_ID: number,
	DEALER_KVPS_CODE: string,
};
export default BaseSelect.extend({
	name: selectName(NAME),
	data() {
		return {
			storeObject: NAME,
			valueFieldName: 'OjId',
			apiProvider,
			emptyObject: {
				value: null,
				text: null,
			},
		};
	},
	computed: {
		isDisabled():boolean {
			return this.pageMode === PageMode.EDIT;
		},
	},
	methods: {
		dbToBaseMapper(data: Data) {
			return {
				value: data.OJ_ID,
				text: data.DEALER_KVPS_CODE,
			};
		},
	},
});
